import apiClient from './apiClient';

export const cambioEstadoService = {
    async getHistorialEstados(idTramite) {
        try {
            const tramiteId = parseInt(idTramite);
            const response = await apiClient.get(`/tramites/${tramiteId}/estados`);
            return response.data;
        } catch (error) {
            throw new Error('Error al obtener el historial de estados');
        }
    },

    async getEstadosDisponibles() {
        try {
            const response = await apiClient.get('/estados');
            return response.data;
        } catch (error) {
            throw new Error('Error al cargar los estados disponibles');
        }
    },

    // Fecha de ingreso = inicio del primer estado. Para trámites viejos cargados después de
    // empezar: al crearlos el sistema les pone la fecha del día. fechaISO = 'AAAA-MM-DD'.
    async actualizarFechaIngreso(idTramite, fechaISO) {
        try {
            const response = await apiClient.patch(`/tramites/${parseInt(idTramite)}/fecha-ingreso`, { fecha: fechaISO });
            return response.data;
        } catch (error) {
            const status = error?.response?.status;
            const mensaje = error?.response?.data?.message;
            if (status === 403) throw new Error('No tenés permiso para modificar este trámite');
            throw new Error(mensaje || 'No se pudo cambiar la fecha de ingreso');
        }
    },

    async cambiarEstado(idTramite, cambioEstadoData) {
        try {
            const tramiteId = parseInt(idTramite);
            const response = await apiClient.post(
                `/tramites/${tramiteId}/estados`,
                cambioEstadoData
            );
            return response.data;
        } catch (error) {
            throw new Error('Error al cambiar el estado del trámite');
        }
    }
};

export default cambioEstadoService;